module.exports = __webpack_public_path__ + "static/media/leg-right-back.801e1fd8.png";